document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector(".bundle_sidebar_toogle_mobile");
  const sidebar = document.querySelector(".byob_sidebar");
  const overlay = document.querySelector(".byob_sidebar_overlay");

  if (toggleButton && sidebar && overlay) {
  toggleButton.addEventListener("click", function (event) {
    event.stopPropagation();
    const isActive = sidebar.classList.contains("active");
    sidebar.classList.toggle("active");
    overlay.classList.toggle("active");

    // Optional: Add/remove body lock class if needed
    document.body.classList.toggle("drawer-open", !isActive);
  });

  overlay.addEventListener("click", function () {
    sidebar.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("drawer-open");
  });
  }  
});

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".byob-section");
  const navLinks = document.querySelectorAll(".nav_item");

  const observer = new IntersectionObserver(entries => {
    let visibleEntry = entries.reduce((max, entry) =>
      entry.intersectionRatio > (max?.intersectionRatio || 0) ? entry : max,
      null
    );

    if (visibleEntry && visibleEntry.isIntersecting) {
      const id = visibleEntry.target.getAttribute("id");
      const tab = document.querySelector(`.nav_item[href="#${id}"]`);

      if (tab) {
        navLinks.forEach(link => link.classList.remove("active"));
        tab.classList.add("active");

        // 👇 This line makes the tab scroll into view
        tab.scrollIntoView({
          behavior: "smooth",   // smooth scrolling
          inline: "center",     // center horizontally (use "nearest" or "start" if you prefer left alignment)
          block: "nearest"      // prevent vertical jump
        });
      }
    }
  }, { threshold: [0.3, 0.5, 0.7] });

  sections.forEach(section => {
    observer.observe(section);
  });
});

function update_quick_slider_Ingredients() {
  new Swiper('.quick_slider_Ingredients', {
        loop: false,
        slidesPerView: 2.2,
        paginationClickable: true,
        spaceBetween: 7,
       autoHeight: false,
        breakpoints: {
            1920: {
                slidesPerView: 2.2,
                spaceBetween: 7
            },
            1028: {
                slidesPerView: 2.2,
                spaceBetween: 7
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 7
            }
        }
    });
}

document.addEventListener("click", function (e) {
  if( location.href.split("/").pop() != "byob"){
    return ;
  }
  const target = e.target.closest(".bls__page-faq-items.bls-toggle");

  if (target) {
    e.preventDefault();
    target.classList.toggle("active");
    const content = target.querySelector(".bls__page-faq-content");
    if (content) {
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    }
  }
});

function initSwiperImage() {
  new Swiper(".drawer_product_image", {
    slidesPerView: 2.1,
    spaceBetween: 7,
     navigation: {
      nextEl: ".image_button-next",
      prevEl: ".image_button-prev",
    },
  }); 
} 

document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest("[data-close-drawer]");
  
  if (closeBtn) {
    e.preventDefault();
    
    const drawer = closeBtn.closest(".product-drawer");
    if (drawer) {
      drawer.classList.add("hidden");
    }
  }
});

function setDrawerPricing() {
  const discountPercent = window.cust_discount;
  let saving = 0;

  $(".drawer-item-pricing span").each(function () {
    const originalPrice = parseFloat($(this).text().replace(/[^0-9.]/g, ""));
    if (!isNaN(originalPrice)) {
      const discounted = (originalPrice * (100 - discountPercent) / 100).toFixed(2);
      saving = (originalPrice - discounted).toFixed(2);
      $(this).text('$' + discounted);
    }
  });

  $(".discont_saving .label-discount").text(discountPercent + "% OFF");

  // Update all label-savings elements
  $(".discont_saving .label-savings").each(function () {
    $(this).text($(this).text().replace("xxx", saving));
  });
}




document.addEventListener("click", async function (e) {
  const target = e.target.closest(".learn_more");

  if (target) {
    e.preventDefault();

    const section_name = "byob-product-details-drawer";
    const handle = target.getAttribute("data-handle");
    const resp   = await fetchGet(`/products/${handle}?sections=${section_name}`);
    const html   = resp[section_name];
    document.querySelector("#drawer-ajax")?.remove();

    const tempDiv = document.createElement("div");
    tempDiv.id = "drawer-ajax";
    tempDiv.innerHTML = html;
    
    document.querySelector("#MainContent .shopify-section").appendChild(tempDiv);
    setDrawerPricing();

    
    const interval = setInterval(function () {
      lightGallery(document.getElementById('lightgallery'), {
        thumbnail: true
      });
    
      clearInterval(interval); // Stop after one execution
    }, 300);
    
    initSwiperImage();
    update_quick_slider_Ingredients();
    setDrawerButtons(handle);
  }
});


function variantAlreadyExists(idToCheck){
  const items = cust_bundle;
  return items.some(item => item.id == idToCheck);
}

function setDrawerButtons(handle){
  const vid = $(`.product__quick_add[data-product-handle="${handle}"]`).attr("data-variant-id");
  const exists = variantAlreadyExists(vid);
  if( exists ){
    $(`.add-to-cart.bundle-add-to-cart[variant-id="${vid}"]`).addClass("added add_bundle_btn");
  }
}

async function fetchGet(url) {
    const response = await fetch(url);
    return response.json();
}

async function fetchPost(url, data) 
{
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)      
    });  
    return await response.json();  
}

function generateBundleCartPayload() {
  let payload = []; 
  for (let bundle of cust_bundle) {
    payload.push({
      id: Number(bundle.id),
      quantity: Number(bundle.quantity),
      properties: {
        _bundle: true
      }
    });
  }
  payload = addFreeProducts(payload);
  return { items: payload };
}


function addFreeProducts(payload){
  const arr = Array.from(document.querySelectorAll('[free-gift-variant-id]')).map(el => Number(el.getAttribute('free-gift-variant-id')));
  for (let bundle of arr) {
    payload.push({
      id: Number(bundle),        
      quantity: 1,
      properties: {
        _bundle: true
      }
    });
  }
  return payload;
}


async function addBundleProductToCart(){
  const payload = generateBundleCartPayload();
  const resp = await fetchPost("/cart/add.js", payload);
  return resp;
}


window.cust_bundle = [];

function createBundleItem(bundle) {
  const bundleItem = document.createElement("div");
  bundleItem.className = "bundle-item";
  bundleItem.setAttribute("data-id", bundle.id);

  // Conditional price rendering
  let priceHTML = "";
  if (bundle.salePrice !== "") {
    priceHTML = `<span>${bundle.salePrice}</span> <del>${bundle.comparePrice}</del>`;
  } else {
    priceHTML = `<span>${bundle.comparePrice}</span>`;
  }

  bundleItem.innerHTML = `
    <img src="${bundle.img}" alt="${bundle.title}">
    <div class="info">
      <p class="title">${bundle.title}</p>
      <p class="meta">${bundle.product_info}</p>
    </div>
    <div class="prie_delete">
      <div class="price">
        ${priceHTML}
      </div>
      <button class="remove">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#858686" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M2.34375 3.28125H12.6562" stroke="#858686" stroke-miterlimit="10" stroke-linecap="round"></path>
          <path d="M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67694 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67694 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125M7.5 5.15625V11.7188M5.39062 5.15625L5.625 11.7188M9.60938 5.15625L9.375 11.7188" stroke="#858686" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
    </div>
  `;

  const container = document.querySelector(".bundle-cart .bundle-items");
  if (container) {
    container.appendChild(bundleItem);
  }
}



function addProductToBundle(variantId, title="", img="", salePrice="", comparePrice="", product_info="") {
  const existingProduct = cust_bundle.find(product => product.id === variantId);

  if (!existingProduct) {
    const handle =  $(`.product__quick_add[data-variant-id="${variantId}"]`).attr("data-product-handle");
    
    const newProduct = {
      id: variantId,
      title: title,
      img: img,
      salePrice: salePrice,
      comparePrice: comparePrice,
      quantity: 1,
      product_info: product_info,
      handle: handle
    };
    cust_bundle.push(newProduct);
  } else {
    existingProduct.quantity += 1;
  }
  renderBundleSummary();
}

function removeProductFromBundle(productId) {
  // cust_bundle = cust_bundle.filter(p => p.id !== productId);
  removeQtyFromProduct(productId);
  renderBundleSummary();
  qty = calculateQtySelector(productId);
  setQtySelector(productId, qty);
}

function calculateQtySelector(vid) {
  const selector = document.querySelector(`.quantity_selector_byob.show[variant-id='${vid}']`);
  if (selector) {
    const input = selector.querySelector("input");
    if (input) {
      const quantity = Number(input.value);
      const result =  quantity - 1;
      return Number(result);
    }
  }
}

function renderBundleSummary() {
  $(".bundle-item").remove();
  for (const bundle of cust_bundle) {
    for(let i=0; i<bundle.quantity; i++){
      createBundleItem(bundle);
    }
  }
  
  if( location.href.split("/").pop() == "byob"){
  setProgessBar();
  setPricing();
  }
}

function setPricing() {
  const result = calculatePrice();
  const priceContainer = document.querySelector(".bundle-total .total-price");

  if (!result || !priceContainer) return;

  const { RegularPrice, salePrice, discountedPrice } = result;
  const saving = salePrice - discountedPrice;

  priceContainer.querySelector("del").innerText = '$' +  salePrice.toFixed(2);
  priceContainer.querySelector("span").innerText = '$' + discountedPrice.toFixed(2);
  priceContainer.querySelector(".savings").innerText = 'Your total savings $' + saving.toFixed(2);


  const buttonPricing = document.querySelector(".add-bundle.add_bundle_btn.add_loader");
  if( buttonPricing ){
    buttonPricing.querySelector("del").innerText = '$' +  salePrice.toFixed(2);
    buttonPricing.querySelector(".discount-amount").innerText = '$' + discountedPrice.toFixed(2);
  }
}


function setProgessBar(){
  const count = bundleProductCount();
  document.querySelector(".progress-bar .fill").style.width = 20 * count + "%";
  document.querySelector(".bundle-progress .bundle_count strong").innerText = count + "/5";
  document.querySelector(".selected_number_products span.selected_product").innerText = count;
  const remaining = 5 - count;
  if( remaining < 1){
     document.querySelector(".bundle-cart .add-more").style.display = "none";
  }else{
     document.querySelector(".bundle-cart .add-more").style.display = "block";
    document.querySelector(".bundle-cart .add-more strong").innerText = remaining;
  }

  if( count == 5){
    $('.byob_product_add_to_cart').each(function() {
      if (this.classList.length === 1) {
        $(this).addClass('bundle-limit-exceed');
      }
    });

    $('.bundle-cart .add-bundle').addClass("eligable");
  }else{
    $('.bundle-limit-exceed').removeClass('bundle-limit-exceed');
    $('.bundle-cart .add-bundle').removeClass("eligable");
  }
}

function bundleProductCount(){
  return document.querySelectorAll(".bundle-items .bundle-item").length;
}

function setQtySelector(vid, qty) {
  const selector = document.querySelector(`.byob_product_add_to_cart[variant-id="${vid}"]`);
  if (!selector) return;

  const input = document.querySelector(`.quantity_selector_byob[variant-id="${vid}"] input`);
  if (input) input.value = qty;

  if( input.value == "" ){
    selector.classList.remove("added");
  }else if( Number(input.value) < 1 ){
        selector.classList.remove("added");
  }else{
    selector.classList.add("added");
  }
}





function extractNumber(input) {
  const match = input.match(/[\d.]+/);
  return match ? parseFloat(match[0]) : 0;
}


function calculatePrice() {
  let RegularPrice = 0;
  let salePrice = 0;
  let discountedPrice = 0;

  for (let bundle of cust_bundle) {
    RegularPrice += extractNumber(bundle.comparePrice);
    discountedPrice += extractNumber(bundle.salePrice);
    salePrice += extractNumber(bundle.comparePrice);
  }

  return { RegularPrice, salePrice, discountedPrice };
}




function createPayloadOfBundleProduct(vid, showActionMobile) {
  const selectorElem = showActionMobile?.querySelector(".quantity_selector_byob");
  const title = showActionMobile?.querySelector(".limited-line.capitalize")?.innerText ?? null;
  const img = showActionMobile?.querySelector("img")?.src ?? null;
  const comparePrice = showActionMobile?.querySelector(".compare-at-price")?.innerText.trim() ?? ""
  const salePrice = showActionMobile?.querySelector(".actual-price.price__regular")?.innerText.trim() ?? "";
  const quantity = showActionMobile?.querySelector(".byob_product_quantity").value;
  const product_info = showActionMobile?.querySelector(".product_info")?.innerText.trim() ?? "";

  return {
    id: vid,
    title: title,
    image: img,
    quantity: quantity,
    price: salePrice,
    compare_at_price: comparePrice,
    product_info: product_info
  };
}

function removeQtyFromProduct(vid){
  for (let i = 0; i < cust_bundle.length; i++) {
    if (cust_bundle[i].id == vid) {
      if (cust_bundle[i].quantity > 1) {
        cust_bundle[i].quantity -= 1;
      } else {
        cust_bundle.splice(i, 1); // remove item if quantity is 1
      }
      break;
    }
  }
}

function updateCartCount(){
  fetch("/cart.json")
  .then((res) => res.json())
  .then((cart) => {
    document.querySelectorAll(".cart-count").forEach((el) => {
      if (el.classList.contains("cart-count-drawer")) {
        el.innerHTML = `(${cart.item_count})`;
      } else {
        el.innerHTML = cart.item_count;
      }
    });
  });
}


document.addEventListener("click", async function (e) {
  const target = e.target.closest(".add-bundle");
  if (target) {
    target.classList.add("loading");
    e.preventDefault();
    await fetch("/cart/clear");
    await addBundleProductToCart();
    setTimeout(() => {
      locationReloadWithQS();
    }, 2000);
  }
});

function locationReloadWithQS(){
  let url = new URL(window.location.href);
  // Set or update the query parameter
  url.searchParams.set('openCartDrawer', 'true');

  // Reload with the updated URL
  window.location.href = url.toString();
}

async function updateCartAjax(){
      await document.querySelector("cart-notification").updateQuantity();
      updateCartCount();
      document.querySelector("cart-notification").open();
      $('.append_this_progress').load(location.href + " .append_this_progress");
}


document.addEventListener("click", function (e) {
  const target = e.target.closest(".image_posi_add_to_cart .byob_product_add_to_cart");

  if (target) {
    e.preventDefault();

    if( bundleProductCount() == 5 ){
      return ;
    }
    
    const vid = target.getAttribute("variant-id");
    const showActionMobile = target.closest(".show__action-mobile");
    
    const data = createPayloadOfBundleProduct(vid, showActionMobile);
    setQtySelector(vid, 1);
    
    addProductToBundle(data.id, data.title, data.image, data.price, data.compare_at_price, data.product_info)
  }
});

document.addEventListener("click", function (e) {
  const target = e.target.closest(".add-to-cart.bundle-add-to-cart");
  if( target ){
    e.preventDefault();
    const vid = target.getAttribute("variant-id");
    document.querySelector(`.byob_product_add_to_cart[variant-id="${vid}"]`)?.click();    
    document.querySelector("#drawer-ajax")?.remove();
  }
});


document.addEventListener("click", function (e) {
  const target = e.target.closest(".bundle-item button.remove");
  if( target ){
      console.log("clicked");
      e.preventDefault();
      const vid = target.closest(".bundle-item")?.getAttribute("data-id");
      removeProductFromBundle(vid);
  }
});

document.addEventListener("click", function (e) {
  const target_minus = e.target.closest(".quantity_selector_byob.show .minus");
  if (target_minus) {
    const qtySelector   = target_minus.closest(".quantity_selector_byob");
    const inputSelector = qtySelector.querySelector("input.byob_product_quantity");
    if (inputSelector) {
      let value = Number(inputSelector.value) - 1;
      const vid = qtySelector.getAttribute("variant-id");
      setQtySelector(vid, value);
      removeQtyFromProduct(vid);
      if( value < 1){
          removeProductFromBundle(vid);
      }
    }
  }

  // Handle plus button
  const target_plus = e.target.closest(".quantity_selector_byob.show .plus");
  if (target_plus) {
     if( bundleProductCount() == 5 ){
      return ;
    }
     const qtySelector   = target_plus.closest(".quantity_selector_byob");
     const inputSelector = qtySelector.querySelector("input.byob_product_quantity");
     if (inputSelector) {
        let value = Number(inputSelector.value) + 1;
        const vid = qtySelector.getAttribute("variant-id");
        setQtySelector(vid, value);
        addProductToBundle(vid);
    }
  }

  renderBundleSummary();
});


function getFromLocalStorage() {
  const data = localStorage.getItem("cust_bundle");
  return data ? JSON.parse(data) : null;
}

function setToLocalStorage() {
    const value = cust_bundle;
    localStorage.setItem("cust_bundle", JSON.stringify(value));
}


function removeQtySelectorFromCart() {
  const elem = document.querySelector("#form-mini-cart .bls-items");
  const data = getFromLocalStorage();
  if (!elem || ! data) return;

  for (const bundle of data) {
    const item = elem.querySelector(`[product-handle="${bundle.handle}"]`);
    if (!item) continue;

    const qtyInput = item.querySelector("quantity-input");
    if (qtyInput) {
      qtyInput.remove();
    }
  }
}

async function IfBundleProductRemovedClearCart() {
  const resp = await fetchGet("/cart.json");

  const bundleCount = resp.items.filter(item => 
    item.properties && item.properties._bundle
  ).length;

  if( bundleCount != 0 && bundleCount != 5){
    $("cart-notification .main-lodaer").addClass("active-loader");
    await fetch("/cart/clear");
    if( ShopifyAnalytics.meta.page.pageType == "cart"){
      location.reload();
    }else{
      updateCartAjax();
    }

    setTimeout(() => {
      $(".main-lodaer.active-loader").removeClass("active-loader");
    }, 3500);
  }
}

document.addEventListener("click", async function (e) {
  const target = e.target.closest("mini-cart-remove-button");
  const target2 = e.target.closest("cart-remove-button");
  if (target || target2) {
    
    const intervalId = setInterval(() => {
      IfBundleProductRemovedClearCart();
    }, 500);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 2600);
  }

 const progressBars = document.querySelectorAll('.bundle-progress');
  
  progressBars.forEach(bar => {
    const fill = bar.querySelector('.progress-bar .fill');
    const checked = bar.querySelector('.checked');
    const unchecked = bar.querySelector('.unchecked');
  
    if (fill) {
      const width = parseFloat(fill.style.width); // Extract numeric value like 100 from "100%"
      if (width === 100) {
        bar.classList.add('full');
      } else {
        bar.classList.remove('full');
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);

  if (params.has('openCartDrawer') && params.get('openCartDrawer') === 'true') {
    setTimeout(() => {
      location.href = "/pages/byob?open=true";
    }, 2000);
  } else {
    document.body.classList.remove("hidden");

    if (params.has('open') && params.get('open') === 'true') {
      document.querySelector("cart-notification").open();

      // Remove "open" parameter from URL without refresh
      params.delete('open');
      const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      history.replaceState({}, '', newUrl);
    }
  }
});
